module.exports = __webpack_public_path__ + "static/media/img2-1.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/limon/nutricheck_foliar/N/img2-1.png
// module id = 1667
// module chunks = 3